export default {
  root: {},
  selectIcon: {
    top: 'inherit',
  },
};
